export async function tryCatch<T>(fn: Promise<T>): Promise<[any, T]> {
    try {
        return [null, await fn];
    } catch (error) {
        return [error, null as T]
    }
}

export function tryCatchSync<T>(fn: () => T): [any, T] {
    try {
        return [null, fn()];
    } catch (error) {
        return [error, null as T]
    }
}